import api from './api';

export const getGroupRecipes = async (groupId, { search, category } = {}) => {
  const response = await api.get(`/admin/groups/${groupId}/recipes`, { params: { search, category } });
  return response.data;
};

export const getGroupRecipeById = async (groupId, recipeId) => {
  const response = await api.get(`/admin/groups/${groupId}/recipes/${recipeId}`);
  return response.data;
};
